var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"c-panel\"><div ng-form=\"vm.form\" novalidate=\"\" class=\"form layout\"><game-developers-form resource=\"vm.gameDeveloper\" account-settings=\"true\"></game-developers-form></div><div class=\"c-panel__footer\"><div class=\"text-right\"><a id=\"gameDeveloper-save-btn\" ng-click=\"vm.form.$valid &amp;&amp; vm.save()\" ng-class=\"{'is-disabled': vm.form.$invalid}\" rp-except=\"GD_ACCOUNT_MANAGER,AGENCY,ADMIN_AGENCY,OPERATION_MANAGER\" class=\"o-btn c-btn c-btn--outlined\">{{ 'update' | translateWith:'gameDeveloper' }}</a></div></div></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/account/settings/settingsGameDevEdit.jade
 ** module id = 610
 ** module chunks = 0
 **/